import React, { useState } from "react";
import { Container, Accordion, Card } from "react-bootstrap";
import "./faq.css";

const Faq = () => {
  const [activeKey, setActiveKey] = useState(null);

  const faqs = [
    {
      question: "What is BR Travel?",
      answer:
        "BR Travel is a new-age travel company focused on Brotherhood, Relationship, and Management. We provide services in travel, hospitality, and events.",
    },
    {
      question: "How can I book a tour?",
      answer:
        "You can book a tour via our website by selecting your preferred package and submitting an enquiry form. Our team will contact you promptly.",
    },
    {
      question: "Do you offer custom travel packages?",
      answer:
        "Yes! We provide fully customized travel packages based on your preferences and budget. Contact us to discuss your requirements.",
    },
    {
      question: "What payment methods do you accept?",
      answer:
        "We accept all major credit/debit cards, UPI, and online banking transfers. Payment details will be shared during the booking process.",
    },
    {
      question: "What is your cancellation policy?",
      answer:
        "Cancellation policies vary by package. Please refer to the package terms and conditions or contact our support for detailed information.",
    },
  ];

  const toggleAccordion = (key) => {
    if (activeKey === key) {
      setActiveKey(null);
    } else {
      setActiveKey(key);
    }
  };

  return (
  <>
    {/* FAQ Hero */}
    <section className="faq-hero">
      <Container>
        <h1>Frequently Asked Questions</h1>
        <p>Everything you need to know about BR Travel</p>
      </Container>
    </section>

    {/* FAQ Content */}
    <section className="faq-section py-5">
      <Container>
        <Accordion activeKey={activeKey}>
          {faqs.map((faq, index) => (
            <Card key={index} className="mb-3 faq-card">
              <Accordion.Item eventKey={index.toString()}>
                <Accordion.Header
                  onClick={() => toggleAccordion(index.toString())}
                >
                  {faq.question}
                </Accordion.Header>
                <Accordion.Body>{faq.answer}</Accordion.Body>
              </Accordion.Item>
            </Card>
          ))}
        </Accordion>
      </Container>
    </section>
  </>
);

};

export default Faq;
